import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { assign } from '../../../shared/Assign';
import { FormGroup, ControlLabel, Row, Col, Checkbox } from 'react-bootstrap';
import DateTime from 'react-datetime';
import { IWorkingHour } from '../Entities';
import moment from 'moment';

interface IProps {
    workingHours: Readonly<IWorkingHour[]>;
    onChangeStartTime: (dayofweek: number, time: string) => void;
    onChangeEndTime: (dayofweek: number, time: string) => void;
    onChangeIsAvailable: (dayofweek: number, isAvailable: boolean) => void;
}

class WorkingHoursForm extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);

        this.state = {};
    }

    getDayName(day: number) {
        let translationKey = 'photographercalendar/workinghours/modal/days';
        switch (day) {
            case 0:
                return Translate(`${translationKey}/sunday`);
            case 1:
                return Translate(`${translationKey}/monday`);
            case 2:
                return Translate(`${translationKey}/tuesday`);
            case 3:
                return Translate(`${translationKey}/wednesday`);
            case 4:
                return Translate(`${translationKey}/thursday`);
            case 5:
                return Translate(`${translationKey}/friday`);
            case 6:
                return Translate(`${translationKey}/saturday`);
            default:
                break;
        }
    }

    reorderDaysBasedOnLocale(inWorkingHours: IWorkingHour[]): IWorkingHour[] {
        let firstDayOfWeek = 1;
        let workingHours = assign([], inWorkingHours);

        if (workingHours && workingHours.length > 0) {
            while (firstDayOfWeek !== workingHours[0].day) {
                workingHours.push(workingHours.shift());
            }
        }

        return workingHours;
    }

    render() {
        const { workingHours } = this.props;
        const whours = this.reorderDaysBasedOnLocale(workingHours.map((x) => x));

        return (
            <div>
                {whours.map((workHours: IWorkingHour, index) => {
                    let nameOfDay = this.getDayName(workHours.day);

                    return (
                        <FormGroup key={'workinghours-' + index}>
                            <ControlLabel>{nameOfDay}</ControlLabel>
                            <Row>
                                <Col lg={3}>
                                    <DateTime
                                        dateFormat={false}
                                        viewMode="time"
                                        value={formatString(workHours.start)}
                                        onChange={(time: string) =>
                                            this.props.onChangeStartTime(workHours.day, time)
                                        }
                                        onFocus={() =>
                                            document
                                                .getElementById(`rdt-wh-start-${nameOfDay}`)
                                                .blur()
                                        }
                                        inputProps={{
                                            id: `rdt-wh-start-${nameOfDay}`,
                                            disabled: !workHours.isAvailable ? 'disabled' : ''
                                        }}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <DateTime
                                        dateFormat={false}
                                        viewMode="time"
                                        value={formatString(workHours.end)}
                                        onChange={(time: string) =>
                                            this.props.onChangeEndTime(workHours.day, time)
                                        }
                                        onFocus={() =>
                                            document
                                                .getElementById(`rdt-wh-end-${nameOfDay}`)
                                                .blur()
                                        }
                                        inputProps={{
                                            id: `rdt-wh-end-${nameOfDay}`,
                                            disabled: !workHours.isAvailable ? 'disabled' : ''
                                        }}
                                    />
                                </Col>
                                <Col lg={4}>
                                    <Checkbox
                                        inline
                                        name={`IsAvailable${index}`}
                                        checked={!workHours.isAvailable}
                                        onChange={() => {
                                            this.props.onChangeIsAvailable(
                                                workHours.day,
                                                !workHours.isAvailable
                                            );
                                        }}
                                    >
                                        <span>
                                            {Translate(
                                                'photographer/modal/form/calendar/not-available'
                                            )}
                                        </span>
                                    </Checkbox>
                                </Col>
                            </Row>
                        </FormGroup>
                    );
                })}
            </div>
        );
    }
}

function formatString(time: string) {
    try {
        return time.split(':')[0] + ':' + time.split(':')[1];
    } catch (error) {
        return moment(time).locale('en').format('HH:mm');
    }
}

export default WorkingHoursForm;
